<template>
  <div class="protocol-wrapper">
    <protocol-header></protocol-header>
    <protocol-content></protocol-content>
  </div>
</template>

<script>
import ProtocolHeader from '../../components/protocol/header.vue'
import ProtocolContent from '../../components/protocol/protocol.vue'
export default {
  components: {
    ProtocolHeader,
    ProtocolContent
  }
}
</script>



// WEBPACK FOOTER //
// protocol.vue?c72ed1d4